import React from "react";

export interface IconArrowUpProps extends React.SVGProps<SVGSVGElement> {
  width?: number | string;
  height?: number | string;
  fill?: string;
}

export const IconArrowUp: React.FC<IconArrowUpProps> = ({
  width = 25,
  height = 25,
  fill = "#006231",
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 25 25"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M1.63207 14.3706L0.393371 13.1319C-0.131124 12.6074-0.131124 11.7593 0.393371 11.2404L11.2348 0.393371C11.7593 -0.131124 12.6074 -0.131124 13.1263 0.393371L23.9678 11.2348C24.4922 11.7593 24.4922 12.6074 23.9678 13.1263L22.729 14.365C22.199 14.8951 21.3341 14.8839 20.8152 14.3427L14.4152 7.62471V23.6609C14.4152 24.403 13.8182 25 13.0761 25H11.2906C10.5485 25 9.95146 24.403 9.95146 23.6609V7.62471L3.54592 14.3483C3.02701 14.8951 2.16215 14.9063 1.63207 14.3706Z" />
  </svg>
);
